<template>
  <div class="cms-list-container">
    <a-card :bordered="false" class="cms-card">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1 class="page-title">
          <span class="title-text">资讯中心</span>
          <span class="title-bg">NEWS CENTER</span>
        </h1>
      </div>

      <!-- 结果统计 -->
      <div class="result-header">
        <div class="result-count">
          共找到<span class="count-number">{{ info.total || 0 }}</span>篇资讯
        </div>
      </div>

      <a-list
        item-layout="vertical"
        size="large"
        :pagination="pagination"
        :data-source="cmsDataSource"
        :loading="loading"
      >
        <a-list-item 
          slot="renderItem" 
          :key="item.id" 
          slot-scope="item"
          class="cms-list-item"
        >
          <div class="news-item-wrapper">
            <!-- 左侧图标区域 -->
            <div class="news-icon-wrapper" :class="{ 'has-cover': item.cmsCover && !item._coverBroken }">
              <div v-if="item.cmsCover && !item._coverBroken" class="news-cover">
                <img
                  :src="getCmsCover(item)"
                  alt="文章封面"
                  @error="markCoverBroken(item)"
                />
              </div>
              <div v-else class="news-icon">
                <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                  <!-- 文档背景 -->
                  <rect x="20" y="15" width="80" height="90" rx="4" fill="#1890ff" opacity="0.1"/>
                  <rect x="20" y="15" width="80" height="90" rx="4" fill="none" stroke="#1890ff" stroke-width="2"/>
                  
                  <!-- 文档线条 -->
                  <line x1="30" y1="35" x2="90" y2="35" stroke="#1890ff" stroke-width="2"/>
                  <line x1="30" y1="50" x2="80" y2="50" stroke="#1890ff" stroke-width="1.5" opacity="0.7"/>
                  <line x1="30" y1="65" x2="85" y2="65" stroke="#1890ff" stroke-width="1.5" opacity="0.7"/>
                  
                  <!-- 小人物 -->
                  <circle cx="60" cy="85" r="8" fill="#1890ff"/>
                  <rect x="56" y="93" width="8" height="12" rx="2" fill="#1890ff"/>
                  
                  <!-- 装饰元素 -->
                  <circle cx="15" y="25" r="3" fill="#1890ff" opacity="0.3"/>
                  <circle cx="105" y="95" r="4" fill="#1890ff" opacity="0.2"/>
                </svg>
              </div>
            </div>
            
            <!-- 右侧内容区域 -->
            <div class="news-content-wrapper">
              <a-list-item-meta>
                <a 
                  slot="title" 
                  @click="toDetail(item)"
                  class="news-title-link"
                >
                  <h3 class="news-title">{{ item.cmsTitile }}</h3>
                </a>
              </a-list-item-meta>
              
              <div v-if="item.cmsDesc" class="news-summary">
                <!-- <span class="summary-label">摘要</span> -->
                <p class="summary-text">
                  {{ item.cmsDesc }}
                </p>
              </div>
              
              <div class="news-meta">
                <span class="news-time">
                  <a-icon type="clock-circle" />
                  <span class="time-text">{{ item.createTime }}</span>
                </span>
              </div>
            </div>
          </div>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>

<script>
import { getAction, getFileAccessHttpUrl } from "@/api/manage";

export default {
  components: {
  },
  data() {
    return {
      info: {},
      cmsDataSource: [],
      loading: false,
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 10,
      },
      queryParam: {
        cmsType: "",
      },
    };
  },
  created() {
    let type = "";
    if (this.$route.query.type) {
      type = this.$route.query.type;
    }
    this.getCmsList(type);
  },
  watch:{
    $route(v){
      this.getCmsList(this.$route.query.type);
    }
  },
  methods: {
    getFileAccessHttpUrl,
    getCmsCover(item) {
      if (!item.cmsCover) {
        return "";
      }
      return this.getFileAccessHttpUrl(item.cmsCover);
    },
    markCoverBroken(item) {
      this.$set(item, "_coverBroken", true);
    },
    getCmsList(type) {
      this.loading = true;
      this.cmsDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: type,
        pageSize: 100,
      }).then((res) => {
        if (res.success) {
          this.info = res.result;
          this.cmsDataSource = res.result.records;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    toDetail(item) {
      let route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, '_blank');
    },
    handleChangeType(v) {},
  },
};
</script>

<style lang="less" scoped>
.cms-list-container {
  //padding: 20px;
  // background: #f0f2f5;
  min-height: 100vh;
  animation: fadeIn 0.5s ease-in-out;
}

.cms-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  background: #fff;
  transition: box-shadow 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }
  
  /deep/ .ant-card-body {
    padding: 32px;
  }
}

// 页面标题
.page-header {
  margin-bottom: 32px;
  text-align: center;
  position: relative;
  padding: 20px 0;
  animation: slideDown 0.6s ease-out;

  .page-title {
    position: relative;
    display: inline-block;
    margin: 0;
    padding: 0;

    .title-text {
      font-size: 36px;
      font-weight: 600;
      color: #333;
      position: relative;
      z-index: 2;
      letter-spacing: 2px;
      animation: slideDown 0.6s ease-out;
    }

    .title-bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 72px;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.03);
      z-index: 1;
      letter-spacing: 8px;
      white-space: nowrap;
      animation: fadeInScale 0.8s ease-out;
    }
  }
}

// 结果头部
.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px 0;
  border-bottom: 2px solid #e8e8e8;
  animation: slideInLeft 0.6s ease-out 0.2s both;

  .result-count {
    font-size: 15px;
    color: #333;
    font-weight: 500;

    .count-number {
      color: #ff6600;
      font-weight: 700;
      font-size: 18px;
      margin: 0 6px;
      animation: countUp 0.6s ease-out;
    }
  }
}

// 动画定义
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes countUp {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.cms-list-item {
  padding: 24px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: fadeInUp 0.6s ease-out;
  animation-fill-mode: both;
  position: relative;

  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.15s; }
  &:nth-child(3) { animation-delay: 0.2s; }
  &:nth-child(4) { animation-delay: 0.25s; }
  &:nth-child(5) { animation-delay: 0.3s; }
  &:nth-child(6) { animation-delay: 0.35s; }
  &:nth-child(7) { animation-delay: 0.4s; }
  &:nth-child(8) { animation-delay: 0.45s; }
  &:nth-child(9) { animation-delay: 0.5s; }
  &:nth-child(10) { animation-delay: 0.55s; }
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
    background: linear-gradient(90deg, rgba(24, 144, 255, 0.1) 0%, transparent 100%);
    transition: width 0.4s ease;
  }
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: linear-gradient(90deg, #f5f9ff 0%, #fff 100%);
    border-radius: 8px;
    padding-left: 20px;
    padding-right: 20px;
    transform: translateX(8px);
    box-shadow: 0 4px 16px rgba(24, 144, 255, 0.15);
    
    &::before {
      width: 4px;
    }
    
    .news-icon-wrapper {
      transform: scale(1.15) rotate(8deg);
      
      svg {
        filter: drop-shadow(0 6px 12px rgba(24, 144, 255, 0.4));
      }
    }
    
    .news-title {
      color: #1890ff;
      transform: translateX(6px);
      
      &::after {
        width: 100%;
      }
    }
    
    .news-summary {
      background: #e6f0ff;

      .summary-text {
        color: #1f1f1f;
      }
    }
    
    .news-time {
      color: #1890ff;
      
      .anticon {
        color: #1890ff;
        transform: rotate(360deg);
      }
    }
  }
}

.news-item-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

.news-icon-wrapper {
  flex-shrink: 0;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(24, 144, 255, 0.1);
    transform: translate(-50%, -50%);
    transition: width 0.4s ease, height 0.4s ease;
  }
  
  &:hover::after {
    width: 120px;
    height: 120px;
  }
}

.news-icon-wrapper.has-cover {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.news-cover {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.4s ease;
  }
}

.cms-list-item:hover .news-cover img {
  transform: scale(1.05);
}

.news-icon {
  width: 100%;
  height: 100%;
  
  svg {
    width: 100%;
    height: 100%;
    transition: all 0.3s ease;
  }
}

.news-content-wrapper {
  flex: 1;
  min-width: 0;
}

.news-title-link {
  display: block;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    text-decoration: none;
  }
}

.news-title {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin: 0 0 12px 0;
  line-height: 1.5;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  display: inline-block;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 2px;
    background: #1890ff;
    transition: width 0.3s ease;
  }
  
  &:hover {
    color: #1890ff;
    
    &::after {
      width: 100%;
    }
  }
}

.news-summary {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 6px;
  background: #f6f9ff;
  border-left: 3px solid #1890ff;
  transition: all 0.3s ease;
}

.summary-label {
  font-size: 12px;
  color: #1d39c4;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.summary-text {
  font-size: 14px;
  color: #595959;
  line-height: 1.7;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 8px;
}

.news-time {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #8c8c8c;
  font-size: 13px;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 4px;
  
  .anticon {
    font-size: 14px;
    color: #bfbfbf;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .time-text {
    font-weight: 400;
    transition: color 0.3s ease;
  }
}

// 淡入向上动画
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .cms-card {
    /deep/ .ant-card-body {
      padding: 16px;
    }
  }
  
  .page-header {
    margin-bottom: 24px;
    padding: 16px 0;

    .page-title {
      .title-text {
        font-size: 28px;
      }

      .title-bg {
        font-size: 48px;
      }
    }
  }
  
  .result-header {
    margin-bottom: 20px;
    padding: 12px 0;
  }
  
  .news-item-wrapper {
    gap: 12px;
  }
  
  .news-icon-wrapper {
    width: 60px;
    height: 60px;
  }
  
  .news-title {
    font-size: 16px;
  }
  
  .news-summary {
    padding: 8px 10px;

    .summary-text {
      font-size: 13px;
      -webkit-line-clamp: 2;
      line-clamp: 2;
    }
  }
  
  .cms-list-item {
    padding: 16px 0;
    
    &:hover {
      padding-left: 12px;
      padding-right: 12px;
      transform: translateX(4px);
    }
  }
}

// 列表项加载动画优化
/deep/ .ant-list-item {
  border-bottom: 1px solid #f0f0f0;
  
  &:last-child {
    border-bottom: none;
  }
}

// 分页样式优化
/deep/ .ant-pagination {
  margin-top: 32px;
  text-align: center;
  animation: slideInLeft 0.6s ease-out 0.4s both;
  
  .ant-pagination-item {
    transition: all 0.3s ease;
    border-radius: 4px;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
      border-color: #1890ff;
    }
  }
  
  .ant-pagination-item-active {
    border-color: #1890ff;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
    
    &:hover {
      border-color: #40a9ff;
      box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
    }
  }
  
  .ant-pagination-prev,
  .ant-pagination-next {
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
    }
  }
}
</style>